import axios from 'axios';
import { getDomainName, objectToQueryString } from '~/utils/urlUtils';

export default class LinkedInFlow {
    static startAuthFlow(redirectPath, redirectQuery) {
        const clientId = process.env.VUE_APP_LINKEDIN_CLIENT_ID;
        const state =
            getDomainName() +
            (redirectPath ? redirectPath : '/redirect') +
            (redirectQuery ? objectToQueryString(redirectQuery) : '');
        const scope = 'r_liteprofile%20r_emailaddress';
        const redirectUri = this.redirectUri(); //'http://localhost:5000/user/authenticate-linkedin';

        window.open(
            `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&scope=${scope}&state=${state}&redirect_uri=${redirectUri}`,
            '_self'
        );
    }

    static async getAccessToken(authCode) {
        const state = getDomainName(); // Is necassary for storing which platform was used during registration
        return axios({
            method: 'GET',
            url: `${
                process.env.VUE_APP_IDENTITY_SERVER_URL
            }user/authenticate-linkedin/?code=${authCode}&state=${state}`,
        });
    }

    static redirectUri() {
        return ''.concat(
            process.env.VUE_APP_IDENTITY_SERVER_URL,
            'user/authenticate-linkedin/callback'
        );
    }
}
